// Encodes URI but also encodes special characters. Specifically parentheses that we can have in insurance values.
// router.navigate fails to encode certain characters.
// This functions helps us handle cases like:  Optum/United-EAP (CO).
export const fixedEncodeURIComponent = (str: string): string => encodeURIComponent(str)
  .replace(
    /[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`
  );
